module.exports = __webpack_public_path__ + "media/assets/avatars/hokenplanner-img1-f42faeb01c87f0484aa78ef8bbe8c199.svg";